import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconWehagoFill = ({ width, height, fill, ...props }: IconProps) => {
  const gradientId = 'wehagoFillGradient';

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill ?? `url(#${gradientId})`}
        d="M15.815 12c0-2.173-1.75-3.86-3.815-3.86S8.185 9.828 8.185 12s1.75 3.86 3.815 3.86v5.64a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19v-5.64c2.065 0 3.815-1.687 3.815-3.86Z"
      />
      <defs>
        <radialGradient
          id={gradientId}
          cx="18.765"
          cy="5.365"
          r="18.94"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#38E0FA" />
          <stop offset="1" stopColor="#1C90FC" />
        </radialGradient>
      </defs>
    </Svg>
  );
};

export default IconWehagoFill;
